import React, { useState, useEffect, useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView, Switch, TextInput, Platform, ActivityIndicator } from 'react-native';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { Ionicons } from '@expo/vector-icons';
import { uiVar } from './floodlight/uiStyleCss';
import { ADM_DISPLAY } from './floodlight/vars/admin';

// All OpticOdds leagues organized by sport (960 total) - COMPREHENSIVE
const ALL_LEAGUES = {
  soccer: { name: 'Soccer', leagues: ['afc_-_asian_cup_women', 'afc_-_asian_cup_women_qualifiers', 'afc_-_challenge_league', 'afc_-_champions_league', 'afc_-_champions_league_2', 'albania_-_kategoria_e_pare', 'albania_-_kategoria_superiore', 'albania_-_kupa_e_shqiperise', 'algeria_-_cup', 'algeria_-_ligue_1', 'algeria_-_ligue_2', 'andorra_-_copa_constitucio', 'andorra_-_primera_divisio', 'andorra_-_segona_divisio', 'angola_-_girabola', 'argentina_-_copa_argentina', 'argentina_-_primera_division', 'argentina_-_primera_nacional', 'armenia_-_1st_league', 'armenia_-_cup', 'armenia_-_premier_league', 'asean_-_club_championship', 'australia_-_a-league', 'australia_-_a-league_women', 'australia_-_capital_npl', 'australia_-_championship', 'australia_-_cup', 'australia_-_northern_nsw_npl', 'australia_-_nsw_npl', 'australia_-_queensland_npl', 'australia_-_queensland_premier_league', 'australia_-_south_australia_npl', 'australia_-_tasmania_npl', 'australia_-_victoria_npl', 'australia_-_victoria_premier_league_1', 'austria_-_2_liga', 'austria_-_bundesliga', 'austria_-_ofb_cup', 'azerbaijan_-_1st_division', 'azerbaijan_-_cup', 'azerbaijan_-_premier_league', 'bahrain_-_premier_league', 'belarus_-_cup', 'belarus_-_pervaya_league', 'belarus_-_premier_league', 'belgium_-_challenger_pro_league', 'belgium_-_cup', 'belgium_-_jupiler_pro_league', 'belgium_-_womens_super_league', 'bolivia_-_division_professional', 'bosnia_and_herzegovina_-_cup', 'bosnia_and_herzegovina_-_premier_league', 'bosnia_and_herzegovina_-_prva_liga', 'brazil_-_amapaense', 'brazil_-_baiano', 'brazil_-_baiano_2', 'brazil_-_capixaba', 'brazil_-_carioca', 'brazil_-_catarinense', 'brazil_-_cearense', 'brazil_-_copa_do_brasil', 'brazil_-_gaucho', 'brazil_-_gaucho_2', 'brazil_-_gaucho_3', 'brazil_-_goiano', 'brazil_-_kings_league', 'brazil_-_mineiro_i', 'brazil_-_paraense', 'brazil_-_paranaense', 'brazil_-_serie_a', 'brazil_-_serie_b', 'brazil_-_serie_c', 'brazil_-_serie_d', 'brazil_-_supercopa', 'bulgaria_-_cup', 'bulgaria_-_parva_liga', 'bulgaria_-_vtora_liga', 'caf_-_africa_cup_of_nations', 'caf_-_africa_cup_of_nations_qualifiers', 'caf_-_african_nations_championship', 'cafa_-_nations_cup', 'canada_-_championship', 'canada_-_premier_league', 'canada_-_soccer_league', 'cecafa_-_clubs_cup', 'chile_-_cup', 'chile_-_primera_b', 'chile_-_primera_division', 'chile_-_supercopa', 'china_-_fa_cup', 'china_-_league_one', 'china_-_league_two', 'china_-_super_league', 'colombia_-_cup', 'colombia_-_primera_a', 'colombia_-_primera_b', 'concacaf_-_caribbean_cup', 'concacaf_-_central_america_cup', 'concacaf_-_champions_cup', 'concacaf_-_champions_cup_women', 'concacaf_-_gold_cup', 'concacaf_-_nations_league', 'conmebol_-_copa_america', 'conmebol_-_copa_america_women', 'conmebol_-_copa_libertadores', 'conmebol_-_copa_sudamericana', 'conmebol_-_nations_league', 'conmebol_-_nations_league_women', 'conmebol_-_recopa', 'cosafa_-_cup', 'costa_rica_-_cup', 'costa_rica_-_liga_de_ascenso', 'costa_rica_-_primera_division', 'croatia_-_1_hnl', 'croatia_-_cup', 'croatia_-_first_nl', 'cyprus_-_cup', 'cyprus_-_first_division', 'cyprus_-_second_division', 'cyprus_-_third_division', 'czech_republic_-_cfl', 'czech_republic_-_cup', 'czech_republic_-_first_league', 'czech_republic_-_fnl', 'czech_republic_-_msfl', 'denmark_-_1st_division', 'denmark_-_2nd_division', 'denmark_-_dbu_pokalen', 'denmark_-_superliga', 'ecuador_-_cup', 'ecuador_-_serie_a', 'ecuador_-_serie_b', 'egypt_-_cup', 'egypt_-_premier_league', 'egypt_-_second_division', 'el_salvador_-_primera_division', 'england_-_championship', 'england_-_community_shield', 'england_-_efl_cup', 'england_-_efl_trophy', 'england_-_fa_cup', 'england_-_fa_trophy', 'england_-_league_1', 'england_-_league_2', 'england_-_national_league', 'england_-_premier_league', 'england_-_womens_super_league', 'estonia_-_cup', 'estonia_-_esiliiga', 'estonia_-_esiliiga_b', 'estonia_-_meistriliiga_women', 'estonia_-_premium_liiga', 'ethiopia_-_premier_league', 'ethiopia_-_premier_league_women', 'faroe_islands_-_1_deild', 'faroe_islands_-_cup', 'faroe_islands_-_premier_league', 'fifa_-_arab_nations_cup', 'fifa_-_club_world_cup', 'fifa_-_intercontinental_cup', 'fifa_-_world_cup', 'fifa_-_world_cup_qualifiers', 'fifa_-_world_cup_u20', 'fifa_-_world_cup_women', 'finland_-_kakkonen', 'finland_-_kolmonen', 'finland_-_suomen_cup', 'finland_-_veikkausliiga', 'finland_-_ykkonen', 'finland_-_ykkosliiga', 'france_-_coupe_de_france', 'france_-_ligue_1', 'france_-_ligue_2', 'france_-_national_1', 'france_-_premiere_ligue', 'france_-_super_cup', 'georgia_-_cup', 'georgia_-_erovnuli_liga', 'georgia_-_erovnuli_liga_2', 'germany_-_bundesliga', 'germany_-_bundesliga_2', 'germany_-_bundesliga_3', 'germany_-_dfb_pokal', 'germany_-_frauen_bundesliga', 'germany_-_kings_league', 'germany_-_super_cup', 'gibraltar_-_football_league', 'gibraltar_-_rock_cup', 'greece_-_cup', 'greece_-_super_league', 'greece_-_super_league_2', 'guatemala_-_liga_nacional', 'guatemala_-_primera_division', 'hong_kong_-_premier_league', 'hungary_-_maygar_kupa', 'hungary_-_nb_i', 'hungary_-_nb_ii', 'hungary_-_nb_iii', 'iceland_-_1_deild', 'iceland_-_1_deild_women', 'iceland_-_2_deild', 'iceland_-_3_deild', 'iceland_-_4_deild', 'iceland_-_besta_deild_karla', 'iceland_-_besta_deild_women', 'iceland_-_football_cup', 'india_-_calcutta_premier_division', 'india_-_durand_cup', 'india_-_league_1', 'india_-_league_2', 'india_-_super_league', 'indonesia_-_liga_1', 'international_-_club_friendlies', 'international_-_finalissima', 'international_-_friendlies', 'international_-_friendlies_women', 'international_-_kings_cup', 'iraq_-_stars_league', 'ireland_-_division_1', 'ireland_-_fai_cup', 'ireland_-_premier_league', 'israel_-_cup', 'israel_-_national_league', 'israel_-_premier_league', 'italy_-_coppa_italia', 'italy_-_kings_league', 'italy_-_serie_a', 'italy_-_serie_a_femminile', 'italy_-_serie_b', 'italy_-_serie_c', 'italy_-_supercoppa', 'jamaica_-_premier_league', 'japan_-_emperor_cup', 'japan_-_j1_league', 'japan_-_j2_league', 'japan_-_j3_league', 'japan_-_league_cup', 'kazakhstan_-_cup', 'kazakhstan_-_first_division', 'kazakhstan_-_premier_league', 'kenya_-_premier_league', 'kings_league_-_club_world_cup', 'kings_league_-_world_cup', 'korea_-_cup', 'korea_-_k1_league', 'korea_-_k2_league', 'korea_-_k3_league', 'korea_-_wk_league', 'kosovo_-_first_league', 'kosovo_-_kupe_e_kosoves', 'kosovo_-_liga_e_dyte', 'kosovo_-_superliga', 'latvia_-_1_liga', 'latvia_-_cup', 'latvia_-_virsliga', 'lebanon_-_premier_league', 'liechtenstein_-_aktiv_cup', 'lithuania_-_1_lyga', 'lithuania_-_2_lyga', 'lithuania_-_a_lyga', 'lithuania_-_cup', 'luxembourg_-_1_division', 'luxembourg_-_coupe', 'luxembourg_-_promotion_d_honneur', 'malaysia_-_super_league', 'malta_-_challenge_league', 'malta_-_fa_trophy', 'malta_-_premier_league', 'mexico_-_liga_de_expansion_mx', 'mexico_-_liga_mx', 'mexico_-_liga_mx_women', 'mexico_-_liga_premier_serie_a', 'moldova_-_cupa', 'moldova_-_liga_1', 'moldova_-_super_liga', 'mongolia_-_premier_league', 'montenegro_-_cfl_1', 'montenegro_-_cfl_2', 'montenegro_-_cup_crne_gore', 'netherlands_-_eerste_divisie', 'netherlands_-_eredivisie', 'netherlands_-_knvb_beker', 'netherlands_-_super_cup', 'netherlands_-_tweede_divisie', 'netherlands_-_vrouwen_eredivisie', 'new_zealand_-_national_league', 'north_america_-_leagues_cup', 'northern_ireland_-_championship', 'northern_ireland_-_premiership', 'north_macedonia_-_cup', 'north_macedonia_-_first_league', 'north_macedonia_-_second_league', 'norway_-_1_divisjon', 'norway_-_2_division', 'norway_-_eliteserien', 'norway_-_nm_cup', 'norway_-_topserien_women', 'olympics_soccer_men', 'olympics_soccer_women', 'panama_-_liga_panamena', 'panama_-_liga_prom', 'paraguay_-_primera_division', 'peru_-_copa_peru', 'peru_-_primera_division', 'peru_-_segunda_division', 'poland_-_cup', 'poland_-_ekstraklasa', 'poland_-_ii_liga', 'poland_-_i_liga', 'portugal_-_league_cup', 'portugal_-_liga_3', 'portugal_-_primeira_liga', 'portugal_-_segunda_liga', 'portugal_-_super_cup', 'portugal_-_taca_de_portugal', 'qatar_-_stars_league', 'romania_-_cupa_romaniei', 'romania_-_liga_i', 'romania_-_liga_ii', 'russia_-_cup', 'russia_-_first_league', 'russia_-_premier_league', 'russia_-_second_league_a', 'russia_-_super_cup', 'san_marino_-_campionato', 'san_marino_-_coppa_titano', 'saudi_arabia_-_division_1', 'saudi_arabia_-_kings_cup', 'saudi_arabia_-_saudi_league', 'scotland_-_challenge_cup', 'scotland_-_championship', 'scotland_-_league_cup', 'scotland_-_league_one', 'scotland_-_league_two', 'scotland_-_premiership', 'scotland_-_scottish_cup', 'serbia_-_kup_srbije', 'serbia_-_prva_liga', 'serbia_-_srspka_liga', 'serbia_-_super_liga', 'singapore_-_premier_league', 'slovakia_-_2_liga', 'slovakia_-_3_liga', 'slovakia_-_slovensky_pohar', 'slovakia_-_superliga', 'slovenia_-_2_snl', 'slovenia_-_cup', 'slovenia_-_prvaliga', 'slovenia_-_wfl', 'south_africa_-_premier_league', 'spain_-_copa_del_rey', 'spain_-_kings_league', 'spain_-_la_liga', 'spain_-_la_liga_2', 'spain_-_liga_f', 'spain_-_primera_federacion', 'spain_-_supercopa', 'sweden_-_allsvenskan', 'sweden_-_damallsvenskan', 'sweden_-_ettan', 'sweden_-_superettan', 'sweden_-_svenska_cupen', 'switzerland_-_challenge_league', 'switzerland_-_cup', 'switzerland_-_promotion_league', 'switzerland_-_super_league', 'thailand_-_thai_league_1', 'turkey_-_1_lig', 'turkey_-_cup', 'turkey_-_super_lig', 'uae_-_league_cup', 'uae_-_pro_league', 'uefa_-_champions_league', 'uefa_-_champions_league_women', 'uefa_-_europa_conference_league', 'uefa_-_europa_league', 'uefa_-_european_championship', 'uefa_-_european_championship_qualifiers', 'uefa_-_european_championship_qualifiers_u21', 'uefa_-_european_championship_u21', 'uefa_-_european_championship_women', 'uefa_-_nations_league', 'uefa_-_nations_league_women', 'uefa_-_super_cup', 'ukraine_-_cup', 'ukraine_-_druha_liha', 'ukraine_-_persha_liha', 'ukraine_-_premier_league', 'uruguay_-_primera_division', 'uruguay_-_segunda_division', 'usa_-_major_league_soccer', 'usa_-_mls_next_pro', 'usa_-_nisa', 'usa_-_npsl', 'usa_-_nwsl', 'usa_-_open_cup', 'usa_-_usl_championship', 'usa_-_usl_league_one', 'usa_-_usl_league_two', 'usa_-_usl_w_league', 'uzbekistan_-_cup', 'uzbekistan_-_professional_league', 'uzbekistan_-_super_league', 'venezuela_-_copa_venezuela', 'venezuela_-_primera_division', 'vietnam_-_v_league_1', 'vietnam_-_v_league_2', 'waff_-_championship', 'waff_-_championship_women', 'wales_-_cymru_championship', 'wales_-_cymru_premier', 'wales_-_welsh_cup', 'zimbabwe_-_premier_league'], topLeagues: ['england_-_premier_league', 'spain_-_la_liga', 'germany_-_bundesliga', 'italy_-_serie_a', 'france_-_ligue_1', 'uefa_-_champions_league', 'uefa_-_europa_league', 'usa_-_major_league_soccer', 'mexico_-_liga_mx', 'brazil_-_serie_a'] },
  basketball: { name: 'Basketball', leagues: ['albania_-_superleague', 'argentina_-_lla', 'argentina_-_llf', 'argentina_-_lnb', 'asia_-_wasl', 'australia_-_big_v', 'australia_-_big_v_women', 'australia_-_nbl', 'australia_-_nbl1', 'australia_-_wnbl', 'australia_-_wnbl1', 'austria_-_bsl', 'austria_-_bsl_2', 'austria_-_cup', 'belgium_-_top_division', 'belgium_-_top_division_women', 'big3', 'bolivia_-_libobasquet', 'bosnia_and_herzegovina_-_prvenstvo', 'bosnia_and_herzegovina_-_prvenstvo_women', 'brazil_-_cbb', 'brazil_-_lbf_women', 'brazil_-_nbb', 'bulgaria_-_nbl', 'canada_-_cebl', 'chile_-_lnb', 'chile_-_lnb_segunda', 'china_-_cba', 'china_-_nbl', 'china_-_wcba', 'colombia_-_lpb', 'costa_rica_-_lsb', 'croatia_-_a1_women', 'croatia_-_premijer_liga', 'croatia_-_prva_muska_liga', 'cyprus_-_division_a', 'cyprus_-_division_a_women', 'czech_republic_-_liga_1', 'czech_republic_-_liga_1_women', 'czech_republic_-_nbl', 'czech_republic_-_zbl', 'denmark_-_basketligaen', 'denmark_-_kvindebasketligaen', 'dominican_republic_-_lnb', 'el_salvador_-_lmb', 'england_-_bbl', 'england_-_slb', 'england_-_slb_women', 'eurocup', 'eurocup_women', 'euroleague', 'euroleague_women', 'fiba_-_3x3_europe_cup', 'fiba_-_3x3_europe_cup_women', 'fiba_-_3x3_world_cup', 'fiba_-_3x3_world_cup_women', 'fiba_-_afrobasket', 'fiba_-_afrobasket_qualifiers', 'fiba_-_afrobasket_women', 'fiba_-_americup', 'fiba_-_americup_qualifiers', 'fiba_-_americup_women', 'fiba_-_asia_cup', 'fiba_-_asia_cup_qualifiers', 'fiba_-_asia_cup_women', 'fiba_-_eurobasket', 'fiba_-_eurobasket_qualifiers', 'fiba_-_eurobasket_qualifiers_women', 'fiba_-_eurobasket_women', 'fiba_-_europe_cup', 'fiba_-_intercontinental_cup', 'fiba_-_world_cup', 'fiba_-_world_cup_qualifiers', 'fiba_-_world_cup_u19', 'finland_-_division_1a', 'finland_-_division_1b', 'finland_-_korisliiga', 'finland_-_korisliiga_women', 'france_-_basketball_cup', 'france_-_basketball_cup_women', 'france_-_leaders_cup_a', 'france_-_lfb_women', 'france_-_lnb_national_1', 'france_-_lnb_pro_a', 'france_-_lnb_pro_b', 'germany_-_bbl', 'germany_-_bbl_pokal', 'germany_-_dbbl', 'germany_-_pro_a', 'germany_-_pro_b', 'greece_-_a1_league', 'greece_-_a1_league_women', 'greece_-_basketball_cup', 'greece_-_elite_league', 'hungary_-_nb1_a', 'hungary_-_nb1_a_women', 'iceland_-_bpl', 'iceland_-_bpl_women', 'iceland_-_division_1', 'indonesia_-_ibl', 'international_-_aba_league', 'international_-_aba_league_2', 'international_-_basketball_friendlies', 'international_-_bnxt_league', 'international_-_cewl', 'international_-_champions_league', 'international_-_enbl', 'international_-_latvia_estonia_bl', 'international_-_vtb_united_league', 'international_-_waba', 'international_-_wbbl', 'iran_-_bsl', 'israel_-_nlb', 'israel_-_super_league', 'israel_-_super_league_women', 'italy_-_a1_women', 'italy_-_basketball_cup', 'italy_-_bb_serie_b', 'italy_-_lega_basket_serie_a', 'italy_-_serie_a2', 'japan_-_b1_league', 'japan_-_b2_league', 'japan_-_wjbl', 'korea_-_kbl', 'korea_-_kbl_cup', 'korea_-_wkbl', 'kosovo_-_bb_superliga', 'latvia_-_nbl', 'lebanon_-_lbl', 'lithuania_-_lfk_cup', 'lithuania_-_lkl', 'lithuania_-_nbl', 'mexico_-_cibacopa', 'mexico_-_lnbp', 'mexico_-_lnbpf', 'montenegro_-_mckl', 'nba', 'ncaab', 'ncaaw', 'new_zealand_-_nbl', 'new_zealand_-_wnbl', 'nicaragua_-_lsb', 'nicaragua_-_lsbf', 'north_macedonia_-_prva_liga', 'norway_-_blno', 'olympics_3x3_basketball_men', 'olympics_3x3_basketball_women', 'olympics_basketball_men', 'olympics_basketball_women', 'paraguay_-_lnb', 'philippines_-_commissioners_cup', 'philippines_-_governors_cup', 'philippines_-_mpbl', 'philippines_-_phillipine_cup', 'philippines_-_preseason_cup', 'poland_-_division_1', 'poland_-_pkl', 'portugal_-_lbp', 'puerto_rico_-_bsn', 'puerto_rico_-_bsnf', 'qatar_-_qbl', 'romania_-_cup', 'romania_-_liga_1', 'romania_-_lnbm', 'russia_-_bsl', 'saudi_arabia_-_sbl', 'serbia_-_kls', 'singapore_-_nbl', 'slovakia_-_sbl', 'slovenia_-_skl', 'spain_-_basketball_cup', 'spain_-_copa_espana', 'spain_-_leb_oro', 'spain_-_liga_acb', 'spain_-_liga_femenina', 'sweden_-_basketligaen', 'sweden_-_basketligaen_women', 'switzerland_-_lna', 'switzerland_-_lna_women', 'switzerland_-_nlb', 'taiwan_-_tpbl', 'tbt', 'turkey_-_bsl', 'turkey_-_bsl_women', 'turkey_-_kupasi', 'turkey_-_tbl', 'uganda_-_nbl', 'ukraine_-_fub_superliga', 'uruguay_-_lub', 'uruguay_-_metro_league', 'usa_-_nba_all_star', 'usa_-_nba_summer_league', 'usa_-_unrivaled', 'usa_-_wnba_all_star', 'venezuela_-_superliga', 'vietnam_-_vba', 'wnba'], topLeagues: ['nba', 'ncaab', 'wnba', 'euroleague', 'eurocup'] },
  football: { name: 'American Football', leagues: ['cfl', 'ncaaf', 'nfl', 'ufl'], topLeagues: ['nfl', 'ncaaf'] },
  hockey: { name: 'Hockey', leagues: ['australia_-_ice_hockey_league', 'austria_-_ice_hockey_league', 'belarus_-_extraliga', 'canada_-_ohl', 'canada_-_qmjhl', 'canada_-_whl', 'champions_hockey_league', 'czech_republic_-_chance_liga', 'czech_republic_-_extraliga', 'denmark_-_superisligaen', 'england_-_elite_league', 'europe_-_hockey_tour', 'finland_-_mestis', 'finland_-_sm_liiga', 'france_-_ligue_magnus', 'germany_-_del', 'germany_-_del_2', 'iihf_-_junior_world_championship', 'iihf_-_world_championship', 'international_-_asia_league', 'international_-_erste_liga', 'kazakhstan_-_vysshaya_league', 'latvia_-_hockey_league', 'ncaah', 'new_zealand_-_nzihl', 'nhl', 'norway_-_elitehockeyligaen', 'olympics_hockey_men', 'olympics_hockey_women', 'poland_-_polska_hokej_liga', 'russia_-_khl', 'russia_-_mhl', 'russia_-_vhl', 'slovakia_-_extraliga', 'slovakia_-_shl', 'sweden_-_hockey_allsvenskan', 'sweden_-_sdhl', 'sweden_-_shl', 'switzerland_-_national_league', 'usa_-_4_nations_faceoff', 'usa_-_ahl', 'usa_-_echl', 'usa_-_pwhl'], topLeagues: ['nhl', 'usa_-_pwhl', 'russia_-_khl'] },
  baseball: { name: 'Baseball', leagues: ['australia_-_abl', 'college_baseball', 'cpbl', 'cuba_-_liga_elite', 'dominican_republic_-_lidom', 'kbo', 'mexico_-_lmb', 'mexico_-_lmp', 'mlb', 'npb', 'puerto_rico_-_la_pro', 'usa_-_milb_aaa', 'usa_-_mlb_all_star', 'venezuela_-_lvbp', 'world_baseball_classic'], topLeagues: ['mlb', 'npb', 'kbo'] },
  mma: { name: 'MMA/Combat', leagues: ['pfl', 'ufc'], topLeagues: ['ufc'] },
  boxing: { name: 'Boxing', leagues: ['boxing_matches'], topLeagues: ['boxing_matches'] },
  tennis: { name: 'Tennis', leagues: ['atp', 'atp_challenger', 'davis_cup', 'itf_men', 'itf_women', 'laver_cup', 'olympics_tennis_men', 'olympics_tennis_women', 'six_kings_slam', 'united_cup', 'utr_men', 'utr_women', 'wta'], topLeagues: ['atp', 'wta'] },
  golf: { name: 'Golf', leagues: ['champions_tour', 'dp_world_tour', 'european_challenge_tour', 'korn_ferry', 'legends_tour', 'liv', 'lpga', 'pga', 'solheim_cup', 'usa_-_the_golf_league'], topLeagues: ['pga', 'lpga', 'liv'] },
  cricket: { name: 'Cricket', leagues: ['acc_-_asia_cup_women', 'acc_-_t20_asia_cup', 'afghanistan_-_domestic_t20', 'australia_-_big_bash_league', 'australia_-_big_bash_league_women', 'australia_-_marsh_one_day_cup', 'australia_-_sheffield_shield', 'australia_-_wncl', 'bangladesh_-_bpl', 'bangladesh_-_dhaka_premier_divison', 'bangladesh_-_ncl_t20', 'england_-_charlotte_edwards_cup', 'england_-_county_championship', 'england_-_county_championship_division_2', 'england_-_one_day_cup', 'england_-_one_day_cup_women', 'england_-_rhf_trophy', 'england_-_t20_blast', 'england_-_t20_blast_women', 'england_-_the_hundred', 'england_-_the_hundred_women', 'icc_-_champions_trophy', 'icc_-_cwc_challenge_league', 'icc_-_cwc_challenge_league_2', 'icc_-_t20_world_cup', 'icc_-_t20_world_cup_qualifiers', 'icc_-_t20_world_cup_qualifiers_women', 'icc_-_test_championship', 'icc_-_world_cup_u19', 'icc_-_world_cup_women', 'india_-_ipl', 'india_-_ranji_trophy', 'india_-_sma_trophy', 'india_-_tamil_nadu_premier_league', 'india_-_vijay_hazare_trophy', 'india_-_wpl', 'international_-_odi_matches', 'international_-_odi_matches_women', 'international_-_t20_matches', 'international_-_t20_matches_women', 'international_-_test_matches', 'international_-_test_matches_women', 'international_-_the_ashes', 'ireland_-_inter_provincial_t20', 'new_zealand_-_ford_trophy', 'new_zealand_-_plunket_shield', 'new_zealand_-_super_smash', 'new_zealand_-_super_smash_women', 'pakistan_-_national_t20_cup', 'pakistan_-_super_league', 'south_africa_-_csa_four_day', 'south_africa_-_csa_one_day', 'south_africa_-_csa_pro20_women', 'south_africa_-_sa20', 'sri_lanka_-_lanka_premier_league', 'sri_lanka_-_premier_trophy', 'sri_lanka_-_super_league_four_day', 'sri_lanka_-_t20_major_clubs', 'usa_-_major_league_cricket', 'west_indies_-_4day_championship', 'west_indies_-_caribbean_premier_league', 'west_indies_-_caribbean_premier_league_women', 'zimbabwe_-_domestic_t20', 'zimbabwe_-_logan_cup', 'zimbabwe_-_pro50'], topLeagues: ['india_-_ipl', 'australia_-_big_bash_league', 'england_-_the_hundred'] },
  esports: { name: 'Esports', leagues: ['call_of_duty', 'crossfire', 'cs2', 'cs_go', 'dota_2', 'kings_of_glory', 'league_of_legends', 'mobile_legends_bang_bang', 'overwatch', 'pubg', 'rainbow_six_siege', 'rocket_league', 'starcraft', 'starcraft_2', 'valorant'], topLeagues: ['cs2', 'league_of_legends', 'valorant', 'dota_2'] },
  rugby_union: { name: 'Rugby Union', leagues: ['england_-_premiership_rugby', 'france_-_top_14', 'international_-_six_nations', 'international_-_the_rugby_championship', 'oceania_-_super_rugby', 'olympics_rugby_7s_men', 'olympics_rugby_7s_women', 'usa_-_major_league_rugby'], topLeagues: ['international_-_six_nations', 'england_-_premiership_rugby'] },
  rugby_league: { name: 'Rugby League', leagues: ['australia_-_nrl', 'australia_-_nrlw', 'australia_-_state_of_origin', 'england_-_super_league'], topLeagues: ['australia_-_nrl'] },
  volleyball: { name: 'Volleyball', leagues: ['argentina_-_liga_argentina', 'argentina_-_liga_argentina_women', 'austria_-_avl', 'austria_-_wvl', 'belgium_-_liga_dames', 'belgium_-_liga_heren', 'brazil_-_superliga', 'brazil_-_superliga_women', 'cev_-_champions_league', 'cev_-_champions_league_women', 'cev_-_cup', 'cev_-_cup_women', 'cev_-_european_gold', 'cev_-_european_gold_women', 'cev_-_european_silver', 'cev_-_european_silver_women', 'china_-_cvl', 'china_-_cvl_women', 'czech_republic_-_vel', 'czech_republic_-_vel_women', 'denmark_-_volleyligaen', 'denmark_-_volleyligaen_women', 'finland_-_mestaruusliiga', 'finland_-_mestaruusliiga_women', 'fivb_-_nations_league', 'fivb_-_nations_league_women', 'fivb_-_world_championship', 'fivb_-_world_championship_women', 'france_-_ligue_a', 'france_-_ligue_a_women', 'germany_-_1st_bundesliga', 'germany_-_1st_bundesliga_women', 'iran_-_super_league', 'italy_-_coppa_italia_a1_women', 'italy_-_coppa_italia_superlega', 'italy_-_serie_a1_women', 'italy_-_superlega', 'japan_-_sv_league', 'japan_-_sv_league_women', 'norway_-_nvbf', 'olympics_volleyball_men', 'olympics_volleyball_women', 'philippines_-_pvl_women', 'poland_-_plusliga', 'russia_-_superliga', 'russia_-_superliga_women', 'south_korea_-_v_league', 'south_korea_-_v_league_women', 'usa_-_ncaawvb'], topLeagues: ['brazil_-_superliga', 'fivb_-_nations_league', 'italy_-_superlega'] },
  handball: { name: 'Handball', leagues: ['croatia_-_hb_premijer_liga', 'czech_republic_-_hb_extraliga', 'denmark_-_handboldligaen', 'denmark_-_hb_division_1', 'denmark_-_kvindeligaen', 'ehf_-_champions_league', 'ehf_-_champions_league_women', 'ehf_-_european_championship', 'ehf_-_european_championship_women', 'ehf_-_european_league', 'ehf_-_european_league_women', 'finland_-_hb_sm_liiga', 'france_-_lnh_division_1', 'germany_-_hbl', 'germany_-_hbl_2', 'greece_-_hb_a1', 'hungary_-_hnb_i', 'iceland_-_urvalsdeild', 'ihf_-_world_championship', 'ihf_-_world_championship_women', 'north_macedonia_-_super_liga', 'norway_-_hb_1_divisjon', 'norway_-_hb_eliteserien_women', 'poland_-_superliga', 'portugal_-_hb_1a_divisao', 'romania_-_liga_nationala', 'romania_-_liga_nationala_women', 'russia_-_super_league', 'serbia_-_superliga', 'slovakia_-_hb_extraliga', 'slovenia_-_1_liga', 'spain_-_asobal', 'sweden_-_handbollsligan', 'switzerland_-_mnla'], topLeagues: ['ehf_-_champions_league', 'germany_-_hbl'] },
  darts: { name: 'Darts', leagues: ['england_-_premier_league_darts', 'modus_-_super_series', 'pdc_-_european_darts_championship', 'pdc_-_european_tour', 'pdc_-_grand_slam_of_darts', 'pdc_-_masters_bahrain', 'pdc_-_masters_saudi_arabia', 'pdc_-_players_championship', 'pdc_-_world_championship', 'pdc_-_world_cup_of_darts', 'pdc_-_world_grand_prix', 'pdc_-_world_matchplay', 'pdc_-_world_matchplay_women', 'pdc_-_world_series_of_darts', 'wdf_-_world_championship', 'wdf_-_world_championship_women'], topLeagues: ['pdc_-_world_championship', 'pdc_-_world_matchplay'] },
  motorsports: { name: 'Motorsports', leagues: ['formula_1', 'nascar_-_cup_series', 'nascar_-_truck_series', 'nascar_-_xfinity_series', 'motogp'], topLeagues: ['formula_1', 'nascar_-_cup_series'] },
  table_tennis: { name: 'Table Tennis', leagues: ['czech_republic_-_tt_cup_men', 'czech_republic_-_tt_liga_pro_men', 'olympics_table_tennis_men', 'olympics_table_tennis_women', 'poland_-_tt_elite_series_men', 'ukraine_-_setka_cup', 'wtt_men', 'wtt_women'], topLeagues: ['wtt_men', 'wtt_women'] },
  floorball: { name: 'Floorball', leagues: ['czech_republic_-_superliga', 'denmark_-_fbl_league', 'finland_-_f_liiga', 'finland_-_f_liiga_women', 'latvia_-_fbl_virsliga', 'norway_-_fbl_eliteserien', 'sweden_-_fbl_superligan', 'sweden_-_fbl_superligan_women', 'switzerland_-_prime_league', 'switzerland_-_prime_league_women'], topLeagues: ['finland_-_f_liiga', 'sweden_-_fbl_superligan'] },
  water_polo: { name: 'Water Polo', leagues: ['fina_-_world_championship', 'fina_-_world_championship_women', 'greece_-_wp_a1_league', 'italy_-_wp_serie_a1', 'len_-_champions_league', 'len_-_champions_league_women', 'len_-_european_championship', 'len_-_european_championship_women', 'olympics_water_polo_men', 'olympics_water_polo_women'], topLeagues: ['len_-_champions_league'] },
  curling: { name: 'Curling', leagues: ['wcf_-_european_championship', 'wcf_-_european_championship_women', 'wcf_-_world_championship', 'wcf_-_world_championship_women', 'olympics_curling_men', 'olympics_curling_mixed', 'olympics_curling_women'], topLeagues: ['wcf_-_world_championship'] },
  lacrosse: { name: 'Lacrosse', leagues: ['ncaa_lacrosse', 'usa_-_national_lacrosse_league', 'usa_-_premier_lacrosse_league'], topLeagues: ['usa_-_premier_lacrosse_league'] },
  aussie_rules: { name: 'Aussie Rules', leagues: ['afl'], topLeagues: ['afl'] },
  futsal: { name: 'Futsal', leagues: ['brazil_-_lnf', 'fifa_-_world_cup_futsal', 'spain_-_primera_division', 'uefa_-_futsal_champions_league', 'uefa_-_european_championship_futsal'], topLeagues: ['brazil_-_lnf'] },
  bandy: { name: 'Bandy', leagues: ['finland_-_bandyliiga', 'sweden_-_elitserien', 'fib_-_world_championship_group_a'], topLeagues: ['sweden_-_elitserien'] },
  swimming: { name: 'Swimming', leagues: ['olympics_swimming_men', 'olympics_swimming_women'], topLeagues: ['olympics_swimming_men'] },
  surfing: { name: 'Surfing', leagues: ['olympics_surfing_men', 'olympics_surfing_women'], topLeagues: ['olympics_surfing_men'] },
  athletics: { name: 'Athletics', leagues: ['olympics_athletics_men', 'olympics_athletics_women'], topLeagues: ['olympics_athletics_men'] },
  cycling: { name: 'Cycling', leagues: ['olympics_cycling_men', 'olympics_cycling_women'], topLeagues: ['olympics_cycling_men'] },
  olympics: { name: 'Olympics', leagues: ['olympics_outrights', 'winter_olympics_outrights'], topLeagues: ['olympics_outrights'] },
  entertainment: { name: 'Entertainment', leagues: ['academy_awards', 'major_league_eating'], topLeagues: ['academy_awards'] },
  politics: { name: 'Politics', leagues: ['united_states', 'us_presidential_election'], topLeagues: ['us_presidential_election'] },
  pesapallo: { name: 'Pesäpallo', leagues: ['finland_-_superpesis', 'finland_-_superpesis_women'], topLeagues: ['finland_-_superpesis'] },
  ebasketball: { name: 'eBasketball', leagues: ['ebasketball_-_valhalla'], topLeagues: ['ebasketball_-_valhalla'] },
  efootball: { name: 'eFootball', leagues: ['efootball_-_valhalla'], topLeagues: ['efootball_-_valhalla'] },
};

const PRESETS = {
  all: { label: 'All Sports & Leagues', description: 'Cache everything OpticOdds offers (960 leagues)' },
  worldMajor: { label: 'World Major Leagues', description: 'Top ~50 most popular leagues globally' },
  topOnly: { label: 'Top Per Sport', description: 'Top leagues from each sport category' },
  usOnly: { label: 'US Sports Only', description: 'NBA, NFL, NHL, MLB, MMA, College' },
  custom: { label: 'Custom Selection', description: 'Choose exactly what you want' },
};

// ⭐ CORE LEAGUES - Cannot be disabled (always-on for API functionality)
const CORE_LEAGUES = {
  // These sports are ALWAYS enabled - users cannot toggle them off
  tennis: ['atp', 'wta'],           // Tennis - always active
  basketball: ['nba', 'wnba'],      // NBA & WNBA
  hockey: ['nhl'],                  // NHL
  mma: ['ufc'],                     // UFC
  football: ['nfl'],                // NFL (Super Bowl)
  baseball: ['mlb'],                // MLB
  soccer: [                         // Major Soccer Leagues
    'england_-_premier_league', 'spain_-_la_liga', 'germany_-_bundesliga',
    'italy_-_serie_a', 'france_-_ligue_1', 'uefa_-_champions_league',
    'usa_-_major_league_soccer', 'mexico_-_liga_mx'
  ],
};

// Helper to check if a sport has core leagues
const hasCoreLeagues = (sport) => sport in CORE_LEAGUES;

// Helper to check if entire sport is a core sport (cannot be fully disabled)
const isCoreSport = (sport) => {
  return ['tennis', 'basketball', 'hockey', 'mma', 'football', 'baseball', 'soccer'].includes(sport);
};

// Helper to check if a specific league is a core league
const isCoreLeague = (sport, league) => {
  return CORE_LEAGUES[sport]?.includes(league) || false;
};

// World's ~50 most popular leagues across all sports
const WORLD_MAJOR_LEAGUES = [
  // Basketball (5)
  'nba', 'ncaab', 'wnba', 'euroleague', 'eurocup',
  // American Football (2)
  'nfl', 'ncaaf',
  // Hockey (3)
  'nhl', 'russia_-_khl', 'usa_-_pwhl',
  // Baseball (3)
  'mlb', 'npb', 'kbo',
  // Soccer - Big 5 Leagues (5)
  'england_-_premier_league', 'spain_-_la_liga', 'germany_-_bundesliga', 
  'italy_-_serie_a', 'france_-_ligue_1',
  // Soccer - European Cups (3)
  'uefa_-_champions_league', 'uefa_-_europa_league', 'uefa_-_europa_conference_league',
  // Soccer - Americas (4)
  'usa_-_major_league_soccer', 'mexico_-_liga_mx', 'brazil_-_serie_a', 'argentina_-_primera_division',
  // Soccer - Other Top (4)
  'netherlands_-_eredivisie', 'portugal_-_primeira_liga', 'saudi_arabia_-_saudi_league', 'scotland_-_premiership',
  // Soccer - International (2)
  'fifa_-_world_cup', 'uefa_-_european_championship',
  // MMA/Boxing (2)
  'ufc', 'boxing_matches',
  // Tennis (2)
  'atp', 'wta',
  // Golf (3)
  'pga', 'lpga', 'liv',
  // Cricket (4)
  'india_-_ipl', 'australia_-_big_bash_league', 'england_-_the_hundred', 'pakistan_-_super_league',
  // Esports (3)
  'cs2', 'league_of_legends', 'valorant',
  // Rugby (2)
  'australia_-_nrl', 'international_-_six_nations',
  // Motorsports (2)
  'formula_1', 'nascar_-_cup_series',
  // Darts (1)
  'pdc_-_world_championship',
];

export default function LeagueManagementTab() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [refreshResult, setRefreshResult] = useState(null);
  const [preset, setPreset] = useState('all');
  const [enabledSports, setEnabledSports] = useState({});
  const [topLeaguesOnly, setTopLeaguesOnly] = useState({});
  const [enabledLeagues, setEnabledLeagues] = useState({}); // Individual league toggles: { sport: { league: true/false } }
  const [expandedSports, setExpandedSports] = useState(new Set()); // Multiple sports can be expanded
  const [searchQuery, setSearchQuery] = useState('');

  // Load config from Firestore
  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      setLoading(true);
      const docRef = doc(db, 'system_config', 'league_settings');
      const docSnap = await getDoc(docRef);
      
      // Build default league states (all enabled by default)
      const defaultLeagues = {};
      Object.entries(ALL_LEAGUES).forEach(([sport, data]) => {
        defaultLeagues[sport] = {};
        data.leagues.forEach(league => {
          defaultLeagues[sport][league] = true;
        });
      });
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPreset(data.preset || 'all');
        setEnabledSports(data.enabledSports || {});
        setTopLeaguesOnly(data.topLeaguesOnly || {});
        // Merge saved league states with defaults (in case new leagues were added)
        const savedLeagues = data.enabledLeagues || {};
        Object.keys(defaultLeagues).forEach(sport => {
          if (savedLeagues[sport]) {
            defaultLeagues[sport] = { ...defaultLeagues[sport], ...savedLeagues[sport] };
          }
        });
        setEnabledLeagues(defaultLeagues);
        setConfig(data);
      } else {
        // Default: all sports enabled
        const defaultEnabled = {};
        const defaultTop = {};
        Object.keys(ALL_LEAGUES).forEach(sport => {
          defaultEnabled[sport] = true;
          defaultTop[sport] = false;
        });
        setEnabledSports(defaultEnabled);
        setTopLeaguesOnly(defaultTop);
        setEnabledLeagues(defaultLeagues);
        setPreset('all');
      }
    } catch (err) {
      console.error('Error loading config:', err);
    } finally {
      setLoading(false);
    }
  };

  const saveConfig = async () => {
    try {
      setSaving(true);
      const docRef = doc(db, 'system_config', 'league_settings');
      await setDoc(docRef, {
        preset,
        enabledSports,
        topLeaguesOnly,
        enabledLeagues,
        updated_at: serverTimestamp(),
      }, { merge: true });
      setRefreshResult({ success: true, message: 'Settings saved! Next refresh will use new config.' });
    } catch (err) {
      console.error('Error saving config:', err);
      setRefreshResult({ success: false, message: 'Failed to save: ' + err.message });
    } finally {
      setSaving(false);
    }
  };

  const applyPreset = (newPreset) => {
    setPreset(newPreset);
    const newEnabled = {};
    const newTop = {};
    const newLeagues = {};
    
    Object.keys(ALL_LEAGUES).forEach(sport => {
      const sportData = ALL_LEAGUES[sport];
      const hasWorldMajor = sportData.leagues.some(l => WORLD_MAJOR_LEAGUES.includes(l));
      newLeagues[sport] = {};
      
      switch (newPreset) {
        case 'all':
          newEnabled[sport] = true;
          newTop[sport] = false;
          // Enable all leagues
          sportData.leagues.forEach(l => { newLeagues[sport][l] = true; });
          break;
        case 'worldMajor':
          // Only enable sports that have world major leagues
          newEnabled[sport] = hasWorldMajor;
          newTop[sport] = true; // Use top leagues filter
          // Enable only world major leagues
          sportData.leagues.forEach(l => {
            newLeagues[sport][l] = WORLD_MAJOR_LEAGUES.includes(l);
          });
          break;
        case 'topOnly':
          newEnabled[sport] = true;
          newTop[sport] = true;
          // Enable only top leagues
          sportData.leagues.forEach(l => {
            newLeagues[sport][l] = sportData.topLeagues.includes(l);
          });
          break;
        case 'usOnly':
          newEnabled[sport] = ['basketball', 'football', 'hockey', 'baseball', 'mma', 'boxing'].includes(sport);
          newTop[sport] = true;
          // Enable only top leagues for US sports
          sportData.leagues.forEach(l => {
            newLeagues[sport][l] = sportData.topLeagues.includes(l);
          });
          break;
        case 'custom':
          // Keep current settings
          newEnabled[sport] = enabledSports[sport] ?? true;
          newTop[sport] = topLeaguesOnly[sport] ?? false;
          sportData.leagues.forEach(l => {
            newLeagues[sport][l] = enabledLeagues[sport]?.[l] ?? true;
          });
          break;
      }
    });
    
    setEnabledSports(newEnabled);
    setTopLeaguesOnly(newTop);
    setEnabledLeagues(newLeagues);
  };

  // Auto-save helper - saves to Firestore immediately
  const autoSave = async (newPreset, newEnabledSports, newTopLeaguesOnly, newEnabledLeagues) => {
    try {
      const docRef = doc(db, 'system_config', 'league_settings');
      await setDoc(docRef, {
        preset: newPreset,
        enabledSports: newEnabledSports,
        topLeaguesOnly: newTopLeaguesOnly,
        enabledLeagues: newEnabledLeagues,
        updated_at: serverTimestamp(),
      }, { merge: true });
    } catch (err) {
      console.error('Auto-save failed:', err);
    }
  };

  const toggleSport = (sport) => {
    // Core sports cannot be disabled
    if (isCoreSport(sport) && enabledSports[sport]) {
      // Already enabled - don't allow disabling
      return;
    }
    const newPreset = 'custom';
    const newEnabledSports = { ...enabledSports, [sport]: !enabledSports[sport] };
    setPreset(newPreset);
    setEnabledSports(newEnabledSports);
    autoSave(newPreset, newEnabledSports, topLeaguesOnly, enabledLeagues);
  };

  const toggleTopOnly = (sport, e) => {
    if (e) e.stopPropagation(); // Prevent triggering expand/collapse
    const newPreset = 'custom';
    const newTopLeaguesOnly = { ...topLeaguesOnly, [sport]: !topLeaguesOnly[sport] };
    setPreset(newPreset);
    setTopLeaguesOnly(newTopLeaguesOnly);
    autoSave(newPreset, enabledSports, newTopLeaguesOnly, enabledLeagues);
  };

  const toggleLeague = (sport, league) => {
    // Core leagues cannot be disabled
    if (isCoreLeague(sport, league)) {
      return;
    }
    const newPreset = 'custom';
    const newEnabledLeagues = {
      ...enabledLeagues,
      [sport]: {
        ...enabledLeagues[sport],
        [league]: enabledLeagues[sport]?.[league] === false ? true : false,
      }
    };
    setPreset(newPreset);
    setEnabledLeagues(newEnabledLeagues);
    autoSave(newPreset, enabledSports, topLeaguesOnly, newEnabledLeagues);
  };

  const toggleExpanded = (sport) => {
    setExpandedSports(prev => {
      const newSet = new Set(prev);
      if (newSet.has(sport)) {
        newSet.delete(sport);
      } else {
        newSet.add(sport);
      }
      return newSet;
    });
  };

  const collapseAll = () => setExpandedSports(new Set());
  const expandAll = () => setExpandedSports(new Set(Object.keys(ALL_LEAGUES)));

  // Global: Select only starred leagues across ALL sports
  const selectOnlyStarredGlobal = () => {
    const newEnabledLeagues = { ...enabledLeagues };
    Object.entries(ALL_LEAGUES).forEach(([sport, sportData]) => {
      newEnabledLeagues[sport] = { ...newEnabledLeagues[sport] };
      sportData.leagues.forEach(league => {
        if (sportData.topLeagues.includes(league) || isCoreLeague(sport, league)) {
          newEnabledLeagues[sport][league] = true;
        } else {
          newEnabledLeagues[sport][league] = false;
        }
      });
    });
    setPreset('custom');
    setEnabledLeagues(newEnabledLeagues);
    autoSave('custom', enabledSports, topLeaguesOnly, newEnabledLeagues);
  };

  // Per-sport bulk selection functions
  const selectAllLeagues = (sport) => {
    const sportData = ALL_LEAGUES[sport];
    const newLeagueState = { ...enabledLeagues[sport] };
    sportData.leagues.forEach(league => {
      newLeagueState[league] = true;
    });
    const newEnabledLeagues = { ...enabledLeagues, [sport]: newLeagueState };
    setPreset('custom');
    setEnabledLeagues(newEnabledLeagues);
    autoSave('custom', enabledSports, topLeaguesOnly, newEnabledLeagues);
  };

  const unselectAllLeagues = (sport) => {
    const sportData = ALL_LEAGUES[sport];
    const newLeagueState = { ...enabledLeagues[sport] };
    sportData.leagues.forEach(league => {
      // Don't disable core leagues
      if (!isCoreLeague(sport, league)) {
        newLeagueState[league] = false;
      }
    });
    const newEnabledLeagues = { ...enabledLeagues, [sport]: newLeagueState };
    setPreset('custom');
    setEnabledLeagues(newEnabledLeagues);
    autoSave('custom', enabledSports, topLeaguesOnly, newEnabledLeagues);
  };

  const selectOnlyStarred = (sport) => {
    const sportData = ALL_LEAGUES[sport];
    const newLeagueState = { ...enabledLeagues[sport] };
    sportData.leagues.forEach(league => {
      if (sportData.topLeagues.includes(league) || isCoreLeague(sport, league)) {
        newLeagueState[league] = true;
      } else {
        newLeagueState[league] = false;
      }
    });
    const newEnabledLeagues = { ...enabledLeagues, [sport]: newLeagueState };
    setPreset('custom');
    setEnabledLeagues(newEnabledLeagues);
    autoSave('custom', enabledSports, topLeaguesOnly, newEnabledLeagues);
  };

  const selectStarredLeagues = (sport) => {
    const sportData = ALL_LEAGUES[sport];
    const newLeagueState = { ...enabledLeagues[sport] };
    // Only enable starred leagues (keep others as-is)
    sportData.topLeagues.forEach(league => {
      newLeagueState[league] = true;
    });
    const newEnabledLeagues = { ...enabledLeagues, [sport]: newLeagueState };
    setPreset('custom');
    setEnabledLeagues(newEnabledLeagues);
    autoSave('custom', enabledSports, topLeaguesOnly, newEnabledLeagues);
  };

  const triggerRefresh = async () => {
    try {
      setRefreshing(true);
      setRefreshResult(null);
      
      // Call the refresh endpoint
      const response = await fetch('https://us-central1-bet-optimized-fe922.cloudfunctions.net/triggerOddsRefresh', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ source: 'admin_panel', tier: 'all' }),
      });
      
      const result = await response.json();
      setRefreshResult({ 
        success: response.ok, 
        message: result.message || (response.ok ? 'Refresh triggered!' : 'Refresh failed'),
        stats: result.stats 
      });
    } catch (err) {
      setRefreshResult({ success: false, message: 'Error: ' + err.message });
    } finally {
      setRefreshing(false);
    }
  };

  // Calculate stats
  const stats = useMemo(() => {
    let totalSports = 0;
    let totalLeagueCount = 0;
    let enabledLeagueCount = 0;
    
    Object.entries(ALL_LEAGUES).forEach(([sport, data]) => {
      totalLeagueCount += data.leagues.length;
      if (enabledSports[sport]) {
        totalSports++;
        // Count individually enabled leagues
        data.leagues.forEach(league => {
          if (enabledLeagues[sport]?.[league] !== false) {
            enabledLeagueCount++;
          }
        });
      }
    });
    
    return { totalSports, totalLeagues: totalLeagueCount, enabledSports: totalSports, enabledLeagues: enabledLeagueCount };
  }, [enabledSports, enabledLeagues]);

  if (loading) {
    return (
      <View style={styles.container}>
        <ActivityIndicator size="large" color="#8B5CF6" />
        <Text style={styles.loadingText}>Loading league configuration...</Text>
      </View>
    );
  }

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.title}>League Management</Text>
        <Text style={styles.subtitle}>
          Control which sports and leagues are cached. Changes take effect on next refresh.
        </Text>
      </View>

      {/* Stats Bar */}
      <View style={styles.statsBar}>
        <View style={styles.statItem}>
          <Text style={styles.statValue}>{stats.enabledSports}</Text>
          <Text style={styles.statLabel}>Sports</Text>
        </View>
        <View style={styles.statItem}>
          <Text style={styles.statValue}>{stats.enabledLeagues}</Text>
          <Text style={styles.statLabel}>Leagues</Text>
        </View>
        <View style={styles.statItem}>
          <Text style={styles.statValue}>960</Text>
          <Text style={styles.statLabel}>Available</Text>
        </View>
      </View>

      {/* Preset Buttons */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Quick Presets</Text>
        <View style={styles.presetGrid}>
          {Object.entries(PRESETS).map(([key, { label, description }]) => (
            <TouchableOpacity
              key={key}
              style={[styles.presetCard, preset === key && styles.presetCardActive]}
              onPress={() => applyPreset(key)}
            >
              <View style={styles.presetHeader}>
                <Ionicons 
                  name={preset === key ? 'checkmark-circle' : 'ellipse-outline'} 
                  size={20} 
                  color={preset === key ? uiVar('adm-accent', '#8B5CF6') : 'rgba(255,255,255,0.4)'} 
                />
                <Text style={[styles.presetLabel, preset === key && styles.presetLabelActive]}>{label}</Text>
              </View>
              <Text style={styles.presetDesc}>{description}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>

      {/* Sports Toggle List */}
      <View style={styles.section}>
        <View style={styles.sectionHeader}>
          <View>
            <Text style={styles.sectionTitle}>Sports Configuration</Text>
            <Text style={styles.sectionSubtitle}>Toggle sports/leagues on/off individually</Text>
          </View>
          <View style={styles.expandCollapseButtons}>
            <TouchableOpacity style={styles.globalStarredBtn} onPress={selectOnlyStarredGlobal}>
              <Ionicons name="star" size={14} color="#F59E0B" />
              <Text style={styles.globalStarredBtnText}>Only Starred (All Sports)</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.expandCollapseBtn} onPress={expandAll}>
              <Ionicons name="expand-outline" size={14} color={uiVar('adm-accent', '#8B5CF6')} />
              <Text style={styles.expandCollapseBtnText}>Expand All</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.expandCollapseBtn} onPress={collapseAll}>
              <Ionicons name="contract-outline" size={14} color={uiVar('adm-accent', '#8B5CF6')} />
              <Text style={styles.expandCollapseBtnText}>Collapse</Text>
            </TouchableOpacity>
          </View>
        </View>
        
        {Object.entries(ALL_LEAGUES).map(([sport, data]) => {
          const isCoreProtected = isCoreSport(sport);
          const coreLeagueCount = CORE_LEAGUES[sport]?.length || 0;
          const isExpanded = expandedSports.has(sport);
          const enabledCount = data.leagues.filter(l => enabledLeagues[sport]?.[l] !== false).length;
          
          return (
          <View key={sport} style={[styles.sportRow, isCoreProtected && styles.sportRowCore]}>
            <TouchableOpacity 
              style={styles.sportHeader}
              onPress={() => toggleExpanded(sport)}
              activeOpacity={0.7}
            >
              <View style={styles.sportInfo}>
                {isCoreProtected ? (
                  <TouchableOpacity 
                    style={styles.lockBadge}
                    onPress={(e) => e.stopPropagation()}
                  >
                    <Ionicons name="lock-closed" size={14} color="#10B981" />
                  </TouchableOpacity>
                ) : (
                  <TouchableOpacity onPress={(e) => { e.stopPropagation(); toggleSport(sport); }}>
                    <Switch
                      value={enabledSports[sport]}
                      onValueChange={() => toggleSport(sport)}
                      trackColor={{ false: 'rgba(255,255,255,0.1)', true: 'rgba(139, 92, 246, 0.5)' }}
                      thumbColor={enabledSports[sport] ? '#8B5CF6' : '#666'}
                    />
                  </TouchableOpacity>
                )}
                <Text style={[styles.sportName, !enabledSports[sport] && styles.sportNameDisabled]}>
                  {data.name}
                </Text>
                {isCoreProtected && (
                  <View style={styles.coreBadge}>
                    <Text style={styles.coreBadgeText}>CORE</Text>
                  </View>
                )}
                <Text style={styles.leagueCount}>
                  {enabledCount}/{data.leagues.length} leagues
                  {isCoreProtected && ` (${coreLeagueCount} protected)`}
                </Text>
              </View>
              <View style={styles.sportActions}>
                <TouchableOpacity 
                  style={[styles.topOnlyBtn, topLeaguesOnly[sport] && styles.topOnlyBtnActive]}
                  onPress={(e) => toggleTopOnly(sport, e)}
                  disabled={!enabledSports[sport]}
                >
                  <Text style={[styles.topOnlyBtnText, topLeaguesOnly[sport] && styles.topOnlyBtnTextActive]}>
                    Top Only
                  </Text>
                </TouchableOpacity>
                <Ionicons 
                  name={isExpanded ? 'chevron-up' : 'chevron-down'} 
                  size={18} 
                  color="rgba(255,255,255,0.4)" 
                />
              </View>
            </TouchableOpacity>
            
            {isExpanded && (
              <View style={styles.leagueList}>
                <View style={styles.leagueListHeader}>
                  <Text style={styles.leagueListTitle}>
                    {topLeaguesOnly[sport] ? 'Top Leagues:' : 'All Leagues:'}
                    {isCoreProtected && ' (Core leagues marked with 🔒)'}
                  </Text>
                  <Text style={styles.leagueListCount}>{enabledCount} enabled</Text>
                </View>
                <View style={styles.bulkActions}>
                  <TouchableOpacity 
                    style={styles.bulkBtn}
                    onPress={() => selectAllLeagues(sport)}
                  >
                    <Ionicons name="checkbox-outline" size={12} color={uiVar('adm-accent', '#8B5CF6')} />
                    <Text style={styles.bulkBtnText}>All</Text>
                  </TouchableOpacity>
                  <TouchableOpacity 
                    style={styles.bulkBtn}
                    onPress={() => selectStarredLeagues(sport)}
                  >
                    <Ionicons name="star" size={12} color="#F59E0B" />
                    <Text style={styles.bulkBtnText}>+ Starred</Text>
                  </TouchableOpacity>
                  <TouchableOpacity 
                    style={styles.bulkBtn}
                    onPress={() => selectOnlyStarred(sport)}
                  >
                    <Ionicons name="star" size={12} color="#F59E0B" />
                    <Text style={styles.bulkBtnText}>Only Starred</Text>
                  </TouchableOpacity>
                  <TouchableOpacity 
                    style={[styles.bulkBtn, styles.bulkBtnDanger]}
                    onPress={() => unselectAllLeagues(sport)}
                  >
                    <Ionicons name="close-circle-outline" size={12} color="#EF4444" />
                    <Text style={[styles.bulkBtnText, styles.bulkBtnTextDanger]}>None</Text>
                  </TouchableOpacity>
                </View>
                <View style={styles.leagueGrid}>
                  {(topLeaguesOnly[sport] ? data.topLeagues : data.leagues).map(league => {
                    const isCore = isCoreLeague(sport, league);
                    const isEnabled = enabledLeagues[sport]?.[league] !== false;
                    return (
                      <TouchableOpacity 
                        key={league} 
                        style={[
                          styles.leagueGridItem, 
                          isCore && styles.leagueItemCore,
                          !isEnabled && styles.leagueItemDisabled
                        ]}
                        onPress={() => toggleLeague(sport, league)}
                        disabled={isCore}
                      >
                        <View style={styles.leagueItemLeft}>
                          {isCore ? (
                            <View style={styles.leagueLockIcon}>
                              <Ionicons name="lock-closed" size={10} color="#10B981" />
                            </View>
                          ) : (
                            <View style={[styles.leagueCheckbox, isEnabled && styles.leagueCheckboxActive]}>
                              {isEnabled && <Ionicons name="checkmark" size={10} color={uiVar('adm-ink', '#fff')} />}
                            </View>
                          )}
                          <Text 
                            style={[
                              styles.leagueGridText, 
                              isCore && styles.leagueItemTextCore,
                              !isEnabled && styles.leagueItemTextDisabled
                            ]}
                            numberOfLines={1}
                          >
                            {league.replace(/_/g, ' ').replace(/-/g, ' ')}
                          </Text>
                        </View>
                        {data.topLeagues.includes(league) && (
                          <Ionicons name="star" size={8} color="#F59E0B" style={{marginLeft: 2}} />
                        )}
                      </TouchableOpacity>
                    );
                  })}
                </View>
              </View>
            )}
          </View>
        );
        })}
      </View>

      {/* Action Buttons */}
      <View style={styles.actions}>
        <TouchableOpacity 
          style={[styles.actionBtn, styles.saveBtn]} 
          onPress={saveConfig}
          disabled={saving}
        >
          {saving ? (
            <ActivityIndicator size="small" color="#fff" />
          ) : (
            <>
              <Ionicons name="save-outline" size={18} color={uiVar('adm-ink', '#fff')} />
              <Text style={styles.actionBtnText}>Save Configuration</Text>
            </>
          )}
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={[styles.actionBtn, styles.refreshBtn]} 
          onPress={triggerRefresh}
          disabled={refreshing}
        >
          {refreshing ? (
            <ActivityIndicator size="small" color="#fff" />
          ) : (
            <>
              <Ionicons name="refresh-outline" size={18} color={uiVar('adm-ink', '#fff')} />
              <Text style={styles.actionBtnText}>Trigger Refresh Now</Text>
            </>
          )}
        </TouchableOpacity>
      </View>

      {/* Result Message */}
      {refreshResult && (
        <View style={[styles.resultBox, refreshResult.success ? styles.resultSuccess : styles.resultError]}>
          <Ionicons 
            name={refreshResult.success ? 'checkmark-circle' : 'alert-circle'} 
            size={20} 
            color={refreshResult.success ? '#10B981' : '#EF4444'} 
          />
          <Text style={styles.resultText}>{refreshResult.message}</Text>
        </View>
      )}

      {/* Info Box */}
      <View style={styles.infoBox}>
        <Ionicons name="information-circle-outline" size={18} color={uiVar('adm-accent', '#8B5CF6')} />
        <Text style={styles.infoText}>
          The refresh system queries all enabled leagues. Leagues without fixtures are automatically skipped.
          Refresh runs every 5 minutes for core markets, plus additional cycles for derivatives and player props.
        </Text>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: uiVar('adm-paper', '#0b0b0b'),
  },
  content: {
    padding: 16,
  },
  loadingText: {
    color: 'rgba(255,255,255,0.6)',
    marginTop: 12,
    textAlign: 'center',
  },
  header: {
    marginBottom: 20,
  },
  title: { ...ADM_DISPLAY, letterSpacing: uiVar('adm-display-track', 'normal'),
    color: uiVar('adm-ink', '#fff'),
    fontSize: 24,
    fontWeight: '700',
    marginBottom: 8,
  },
  subtitle: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 14,
  },
  statsBar: {
    flexDirection: 'row',
    backgroundColor: uiVar('adm-accent-wash-10', 'rgba(139, 92, 246, 0.1)'),
    borderRadius: 12,
    padding: 16,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: uiVar('adm-accent-wash-20', 'rgba(139, 92, 246, 0.2)'),
  },
  statItem: {
    flex: 1,
    alignItems: 'center',
  },
  statValue: {
    color: uiVar('adm-accent', '#8B5CF6'),
    fontSize: 28,
    fontWeight: '700',
  },
  statLabel: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 12,
    marginTop: 4,
  },
  section: {
    marginBottom: 24,
  },
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  sectionTitle: { ...ADM_DISPLAY, letterSpacing: uiVar('adm-display-track', 'normal'),
    color: uiVar('adm-ink', '#fff'),
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 4,
  },
  sectionSubtitle: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 13,
  },
  expandCollapseButtons: {
    flexDirection: 'row',
    gap: 8,
  },
  expandCollapseBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 6,
    backgroundColor: uiVar('adm-accent-wash-10', 'rgba(139, 92, 246, 0.1)'),
    borderRadius: 6,
    borderWidth: 1,
    borderColor: uiVar('adm-accent-wash-20', 'rgba(139, 92, 246, 0.2)'),
  },
  expandCollapseBtnText: {
    color: uiVar('adm-accent', '#8B5CF6'),
    fontSize: 11,
    fontWeight: '600',
  },
  globalStarredBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: 'rgba(245, 158, 11, 0.15)',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'rgba(245, 158, 11, 0.3)',
  },
  globalStarredBtnText: {
    color: '#F59E0B',
    fontSize: 11,
    fontWeight: '600',
  },
  presetGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 8,
  },
  presetCard: {
    flex: 1,
    minWidth: 140,
    backgroundColor: 'rgba(255,255,255,0.05)',
    borderRadius: 10,
    padding: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.1)',
  },
  presetCardActive: {
    backgroundColor: uiVar('adm-accent-wash-15', 'rgba(139, 92, 246, 0.15)'),
    borderColor: uiVar('adm-accent-wash-40', 'rgba(139, 92, 246, 0.4)'),
  },
  presetHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 6,
  },
  presetLabel: {
    color: uiVar('adm-ink', '#fff'),
    fontSize: 13,
    fontWeight: '600',
  },
  presetLabelActive: {
    color: uiVar('adm-accent', '#8B5CF6'),
  },
  presetDesc: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 11,
    marginLeft: 28,
  },
  sportRow: {
    backgroundColor: 'rgba(255,255,255,0.03)',
    borderRadius: 10,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    overflow: 'hidden',
  },
  sportRowCore: {
    backgroundColor: 'rgba(16, 185, 129, 0.05)',
    borderColor: 'rgba(16, 185, 129, 0.2)',
  },
  lockBadge: {
    width: 32,
    height: 20,
    backgroundColor: 'rgba(16, 185, 129, 0.2)',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
  },
  coreBadge: {
    backgroundColor: 'rgba(16, 185, 129, 0.2)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    marginLeft: 8,
  },
  coreBadgeText: {
    color: '#10B981',
    fontSize: 9,
    fontWeight: '700',
  },
  sportHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12,
  },
  sportInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flex: 1,
  },
  sportName: {
    color: uiVar('adm-ink', '#fff'),
    fontSize: 14,
    fontWeight: '600',
  },
  sportNameDisabled: {
    color: 'rgba(255,255,255,0.4)',
  },
  leagueCount: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
  },
  sportActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  expandBtn: {
    padding: 4,
  },
  topOnlyBtn: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 6,
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  topOnlyBtnActive: {
    backgroundColor: uiVar('adm-accent-wash-30', 'rgba(139, 92, 246, 0.3)'),
  },
  topOnlyBtnText: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 11,
    fontWeight: '600',
  },
  topOnlyBtnTextActive: {
    color: uiVar('adm-accent', '#8B5CF6'),
  },
  leagueList: {
    padding: 12,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: 'rgba(255,255,255,0.06)',
  },
  leagueListHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  leagueListTitle: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 11,
    fontWeight: '600',
    textTransform: 'uppercase',
  },
  leagueListCount: {
    color: uiVar('adm-accent', '#8B5CF6'),
    fontSize: 11,
    fontWeight: '600',
  },
  bulkActions: {
    flexDirection: 'row',
    gap: 8,
    marginBottom: 10,
    flexWrap: 'wrap',
  },
  bulkBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 6,
    backgroundColor: uiVar('adm-accent-wash-10', 'rgba(139, 92, 246, 0.1)'),
    borderRadius: 6,
    borderWidth: 1,
    borderColor: uiVar('adm-accent-wash-20', 'rgba(139, 92, 246, 0.2)'),
  },
  bulkBtnDanger: {
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    borderColor: 'rgba(239, 68, 68, 0.2)',
  },
  bulkBtnText: {
    color: uiVar('adm-accent', '#8B5CF6'),
    fontSize: 11,
    fontWeight: '600',
  },
  bulkBtnTextDanger: {
    color: '#EF4444',
  },
  leagueItems: {
    gap: 4,
  },
  leagueGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  leagueGridItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: 'rgba(255,255,255,0.03)',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.05)',
    width: '32%', // 3 columns with gap
    minWidth: 150,
  },
  leagueGridText: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: 11,
    textTransform: 'capitalize',
    flex: 1,
  },
  leagueItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 10,
    backgroundColor: 'rgba(255,255,255,0.03)',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.05)',
  },
  leagueItemCore: {
    backgroundColor: 'rgba(16, 185, 129, 0.08)',
    borderColor: 'rgba(16, 185, 129, 0.2)',
  },
  leagueItemDisabled: {
    opacity: 0.5,
    backgroundColor: 'rgba(255,255,255,0.01)',
  },
  leagueItemLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    flex: 1,
    overflow: 'hidden',
  },
  leagueCheckbox: {
    width: 16,
    height: 16,
    borderRadius: 3,
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  leagueCheckboxActive: {
    backgroundColor: uiVar('adm-accent-fill', '#8B5CF6'),
    borderColor: uiVar('adm-accent', '#8B5CF6'),
  },
  leagueLockIcon: {
    width: 16,
    height: 16,
    borderRadius: 3,
    backgroundColor: 'rgba(16, 185, 129, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  leagueItemText: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: 13,
    textTransform: 'capitalize',
    flex: 1,
  },
  leagueItemTextCore: {
    color: '#10B981',
    fontWeight: '500',
  },
  leagueItemTextDisabled: {
    color: 'rgba(255,255,255,0.4)',
  },
  topLeagueBadge: {
    padding: 4,
  },
  // Legacy tag styles (kept for backwards compat)
  leagueTags: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  leagueTag: {
    backgroundColor: 'rgba(255,255,255,0.08)',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    flexDirection: 'row',
    alignItems: 'center',
  },
  leagueTagCore: {
    backgroundColor: 'rgba(16, 185, 129, 0.15)',
    borderWidth: 1,
    borderColor: 'rgba(16, 185, 129, 0.3)',
  },
  leagueTagText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 11,
    textTransform: 'capitalize',
  },
  leagueTagTextCore: {
    color: '#10B981',
    fontWeight: '600',
  },
  actions: {
    flexDirection: 'row',
    gap: 12,
    marginBottom: 16,
  },
  actionBtn: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 14,
    borderRadius: 10,
  },
  saveBtn: {
    backgroundColor: uiVar('adm-accent-fill', '#8B5CF6'),
  },
  refreshBtn: {
    backgroundColor: '#10B981',
  },
  actionBtnText: {
    color: uiVar('adm-ink', '#fff'),
    fontSize: 14,
    fontWeight: '600',
  },
  resultBox: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    padding: 14,
    borderRadius: 10,
    marginBottom: 16,
  },
  resultSuccess: {
    backgroundColor: 'rgba(16, 185, 129, 0.1)',
    borderWidth: 1,
    borderColor: 'rgba(16, 185, 129, 0.3)',
  },
  resultError: {
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    borderWidth: 1,
    borderColor: 'rgba(239, 68, 68, 0.3)',
  },
  resultText: {
    color: uiVar('adm-ink', '#fff'),
    fontSize: 13,
    flex: 1,
  },
  infoBox: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    padding: 14,
    backgroundColor: uiVar('adm-accent-wash-8', 'rgba(139, 92, 246, 0.08)'),
    borderRadius: 10,
    borderWidth: 1,
    borderColor: uiVar('adm-accent-wash-20', 'rgba(139, 92, 246, 0.2)'),
  },
  infoText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 12,
    flex: 1,
    lineHeight: 18,
  },
});
